export default "/images/vendor/flag-icons/flags/4x3/jm.svg?bbf9bcce8cefb8d15d88deeb7dfec194";